import { render, staticRenderFns } from "./InboundEmail.vue?vue&type=template&id=405d371e&scoped=true&"
import script from "./InboundEmail.vue?vue&type=script&lang=js&"
export * from "./InboundEmail.vue?vue&type=script&lang=js&"
import style0 from "./InboundEmail.vue?vue&type=style&index=0&id=405d371e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405d371e",
  null
  
)

export default component.exports